import { Close } from 'components/icons'
import { BaseButton } from 'components/library/buttons'
import Translate from 'lang/Translate'

interface ResetConfirmationProps {
	handleCloseModal?: () => void // is inherited via HOC props
	confirm: () => void
	isPractice?: boolean
}

const ResetConfirmation = ({ handleCloseModal = () => { }, confirm, isPractice }: ResetConfirmationProps) => {
	return (
		<div className='create-scenario-modal' data-testid="scenario-reset-confirm">
			<div className='header flex-center border-bottom mb-4 is-justify-content-space-between'>
				<div className='flex-center'>
					<Translate className='is-size-5 has-text-weight-bold' text={isPractice ? "Buttons.reset_practice" : "Buttons.reset_scenario"} />
				</div>
				<div className='flex-center pointer' onClick={handleCloseModal}>
					<Close />
				</div>
			</div>
			<div className='inputs-container'>
				<Translate text={isPractice ? "Content.reset_practice" : "Content.reset_scenario"} />
				<BaseButton autofocus fieldId="" labelKey="Buttons.reset-confirm" buttonStyles='is-primary w-100 mt-4' onClick={confirm} />
				<BaseButton fieldId="" labelKey="Buttons.cancel-reset" buttonStyles='is-text w-100 mb-2 mt-2' onClick={handleCloseModal} />
			</div>
		</div>
	)
}

export default ResetConfirmation